import React from 'react'

const TipoReporteSabana = ({ setTipoReporte, tipoReporte }) => {
  return (
      <div className=" flex flex-col lg:flex-row justify-between text-sm">
      <div className="mb-1">
        <label className="text-gray-100">Academico</label>
        <input 
          type="radio" 
          className="ml-1 mr-2  cursor-pointer my-auto text-azulBrillanteMira" 
          name="detalle" 
          value={"0"} 
          checked={tipoReporte === "0"? true: false} 
          onChange={(e) => setTipoReporte(e.target.value)}/>
      </div>
      <div className="">
        <label className="text-gray-100">Mineduc</label>
        <input 
          type="radio" 
          className="ml-1 mr-2  cursor-pointer my-auto text-azulBrillanteMira" 
          name="resumen" 
          value={"1"} 
          checked={tipoReporte === "1"? true: false} 
          onChange={(e) => setTipoReporte(e.target.value)}/>
      </div>
    </div>    
  )
}

const TipoVista = ({ setTipoReporte, tipoReporte }) => {
    return (
        <div className=" flex flex-col lg:flex-row justify-between text-sm">
        <div className="mb-1">
          <label className="text-gray-100">Detalle</label>
          <input 
            type="radio" 
            className="ml-1 mr-2  cursor-pointer my-auto text-azulBrillanteMira" 
            name="detalle" 
            value={1} 
            checked={tipoReporte === "1"? true: false} 
            onChange={(e) => setTipoReporte(e.target.value)}/>
        </div>
        <div className="">
          <label className="text-gray-100">Resumen</label>
          <input 
            type="radio" 
            className="ml-1 mr-2  cursor-pointer my-auto text-azulBrillanteMira" 
            name="resumen" 
            value={0} 
            checked={tipoReporte === "0"? true: false} 
            onChange={(e) => setTipoReporte(e.target.value)}/>
        </div>
      </div>    
    )
}

const ComboMeses = ({ handleMesChange, idMes }) => {
  return (
    <div className="w-full xl:w-1/2 flex flex-col ">
      <label className="mb-1 text-gray-100 text-sm"></label>
      <select className="rounded-md" onChange={(e) => handleMesChange(e)} value={idMes}>
      <option value={0}>{"--- Seleccione mes ---"}</option>
        <option value={1}>{"Enero"}</option>
        <option value={2}>{"Febrero"}</option>
        <option value={3}>{"Marzo"}</option>
        <option value={4}>{"Abril"}</option>
        <option value={5}>{"Mayo"}</option>
        <option value={6}>{"Junio"}</option>
        <option value={7}>{"Julio"}</option>
        <option value={8}>{"Agosto"}</option>
        <option value={9}>{"Septiembre"}</option>
        <option value={10}>{"Octubre"}</option>
        <option value={11}>{"Noviembre"}</option>
        <option value={12}>{"Diciembre"}</option>
      </select>
    </div>
  )
}

export {
    ComboMeses,
    TipoVista,
    TipoReporteSabana
}